module.exports = __webpack_public_path__ + "1b388caea4aec3f6a95e35dc7c84dbb8.png";